export default {
  API_URL: 'https://api-memorando.letsara.infinitum-ti.com/api',
  OAPI_URL: 'https://api-memorando.letsara.infinitum-ti.com/oapi',
  // API_URL: "http://localhost:2410/api",
  // OAPI_URL: "http://localhost:2410/oapi",
};
